import React from 'react';

export function ImgInsta1(){

    return (

        <>
            <img loading = "lazy" className = "noChange" src = "img/aposentadoriaRural.png"/>
        </>
    );
}